import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class TerritoriesSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: true,
            freeScroll: true,
            cellSelector: '.territory-carousel__slide',
            cellAlign: 'center',
            imagesLoaded: true,
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.territory-carousel__slide');
        this.slidesCount = this.$slides.length;

        if (document.body.clientWidth >= 620 && document.body.clientWidth < 768 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else if (document.body.clientWidth >= 768 && document.body.clientWidth < 1199 && this.slidesCount > 2) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else if (document.body.clientWidth >= 1200 && this.slidesCount > 3) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else {
            this._destroy();
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }
    
    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth >= 620 && document.body.clientWidth < 768 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else if (document.body.clientWidth >= 768 && document.body.clientWidth < 1199 && this.slidesCount > 2) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else if (document.body.clientWidth >= 1200 && this.slidesCount > 3) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else {
            this._destroy();
        }
    }
}

export default TerritoriesSlider;